import CommentsWidgetListItem from './CommentsWidgetListItem';
export default CommentsWidgetListItem;



// WEBPACK FOOTER //
// ./src/components/CommentsWidgetList/components/CommentsWidgetListItem/index.js